exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".offboard-returns-profile {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -ms-flex-wrap: wrap;\r\n      flex-wrap: wrap;\r\n  -webkit-box-align: center;\r\n      -ms-flex-align: center;\r\n          align-items: center;\r\n  gap: 8px 16px;\r\n  margin: 12px 0;\r\n  padding: 12px 16px;\r\n  border: 1px solid #dce2e6;\r\n  border-radius: 4px;\r\n  background: #fff;\r\n}\r\n.offboard-returns-profile h2 { margin: 0; font-size: 15px; font-weight: 600; line-height: 1.5; }\r\n.offboard-returns-profile .offboard-actions { margin: 0; }\r\n.offboard-returns-profile .btn { max-width: 100%; }\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/work/internal-frontend/src/app/content-page/offboarding/offboarding-returns.component.css
// module id = ../../../../../src/app/content-page/offboarding/offboarding-returns.component.css
// module chunks = main